/**
 * Form Row Component
 * The new form row component is now responsible for handling form row status indicator
 *
 * Params:
 *
 */
import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter,
  Inject
} from '@angular/core';
import { FormComponent } from '../form.component';

import type { OnInit, OnDestroy } from '@angular/core';
import type { NgModel } from '@angular/forms';
import type { FormRowStatus } from '../domain/form.domain';

@Component({
  template: '<ng-content />',
  styleUrls: ['./form-row.component.scss'],
  selector: 'td-wb-form-row'
})
export class FormRowComponent implements OnInit, OnDestroy {
  @HostBinding('class.td-wb-form__row--active') focused: boolean = false;
  @HostBinding('class.td-wb-row-error') error: boolean = false;
  @HostBinding('class.td-wb-form__row__narrative') isNarrative: boolean = false;

  @Input()
  @HostBinding('class.td-wb-form__row--border-top') showBorderTop: boolean = false;

  @Input() rowName: string;

  @Output() readonly rowStatusChange: EventEmitter<FormRowStatus> = new EventEmitter<FormRowStatus>();

  id: number = 0;
  private inputControls: Array<NgModel> = new Array<NgModel>();
  private formRowStatus: FormRowStatus;

  constructor(@Inject(FormComponent) private form: FormComponent) {
  }

  ngOnInit(): void {
    this.isNarrative = this.form.formType === 'narrative';
    this.form.addRow(this);
  }

  ngOnDestroy(): void {
    this.form.removeRow(this);
    if (this.isNarrative) {
      this.inputControls.forEach( (inputModel: NgModel): void => {
        this.form.formElement.removeControl(inputModel);
      });
    }
  }

  registerFormControl(inputModel: NgModel): void {
    if (this.isNarrative) {
      this.inputControls.push(inputModel);
      if (this.rowName !== undefined) {
        inputModel.statusChanges.subscribe((): void => {
          this.setRowStatus();
        });
      }
    }
  }

  unRegisterFormControl(inputModel: NgModel): void {
    if (this.isNarrative) {
      const index = this.inputControls.indexOf(inputModel);
      if (index !== -1) {
        this.inputControls.splice(index, 1);
      }
    }
  }

  private setRowStatus(): void {
    const rowStatus: FormRowStatus = {
      name: this.rowName,
      dirty: true,
      valid: true
    };
    this.inputControls.forEach((model: NgModel): void => {
      if (!model.dirty) {
        rowStatus.dirty = false;
      }
      if (!model.valid) {
        rowStatus.valid = false;
      }
    });

    if (this.formRowStatus === undefined ||
      this.formRowStatus.dirty !== rowStatus.dirty ||
      this.formRowStatus.valid !== rowStatus.valid) {
      this.formRowStatus = rowStatus;
      this.rowStatusChange.emit(rowStatus);
    }

    if (rowStatus.dirty || rowStatus.valid) {
      this.form.setRowStatus(rowStatus);
    }
  }
}
